import { TruckingWhitelistRule } from './rule';

/**
 * Which integrations the whitelist actually governs — the ones some rule names with `:`.
 *
 * Filtering is opt-in per integration: a rate from an integration nobody mentioned is always
 * allowed, so connecting a new one never silently loses coverage. The corollary is that rules
 * carrying no integration only bite inside integrations that some *other* rule names, and a
 * whitelist with no `:` token anywhere filters nothing at all.
 */
export const governedIntegrations = (rules: TruckingWhitelistRule[]) =>
  new Set(rules.map((rule) => rule.integration).filter(Boolean) as string[]);

export const isIntegrationGoverned = (governed: Set<string>, integration?: string) => {
  if (!integration) return false;

  const wanted = integration.trim().toUpperCase();

  return [...governed].some((value) => value.toUpperCase() === wanted);
};
